"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../../../../style/variables");
var layout_1 = require("../../../../../layout");
var Body_1 = __importDefault(require("../../../../../Text/Body"));
var Title_1 = __importDefault(require("../../../../../Text/Title"));
var DotBase_1 = __importDefault(require("../../../../Dot/DotBase"));
var Badge_1 = __importDefault(require("../Badge/Badge"));
var DeltaBadge_1 = __importDefault(require("../Badge/DeltaBadge"));
var ChartTooltipContainer_1 = __importDefault(require("../ChartTooltip/ChartTooltipContainer"));
var SharedChartTooltip = function (_a) {
    var label = _a.label, rows = _a.rows, subtext = _a.subtext, customTooltipRowValueFn = _a.customTooltipRowValueFn;
    return (react_1.jsx(ChartTooltipContainer_1.default, null,
        react_1.jsx(layout_1.Flex, { direction: "column", gap: 4 },
            react_1.jsx(layout_1.Flex, { direction: "column" },
                react_1.jsx(Title_1.default, { size: "lg", color: "var(" + variables_1.RootColor.Gray.LIGHT_3 + ")" }, label),
                subtext && (react_1.jsx(Body_1.default, { size: "sm", color: "var(" + variables_1.RootColor.Gray.LIGHT_1 + ")" }, subtext))), rows === null || rows === void 0 ? void 0 :
            rows.map(function (row) { return (react_1.jsx(layout_1.Flex, { gap: 8, key: row.key, justifyContent: "space-between", alignItems: "center" },
                react_1.jsx(layout_1.Flex, { gap: 8, css: { overflow: 'hidden', height: 32 }, alignItems: "center" },
                    react_1.jsx(DotBase_1.default, { color: row.color, css: { border: '2px solid #FFFFFF' }, size: 'xxl' }),
                    react_1.jsx(Body_1.default, { color: "var(" + variables_1.RootColor.Gray.LIGHT_2 + ")", css: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        } }, row.label)),
                react_1.jsx(layout_1.Flex, { gap: 8, alignItems: "center" },
                    react_1.jsx(Body_1.default, { weight: "semibold", color: "var(" + variables_1.RootColor.White + ")" }, customTooltipRowValueFn ? customTooltipRowValueFn(row, row.value) : row.value),
                    row.after))); }))));
};
exports.default = Object.assign(SharedChartTooltip, { Badge: Badge_1.default, DeltaBadge: DeltaBadge_1.default });
